// A live session's feedback may overdraw the balance (wiki/feature-ai-credits.md): a debt reads with a true minus sign.
export function formatCredits(credits: number): string {
  return credits < 0 ? `\u2212${-credits}` : String(credits);
}
